import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(() => ({
  rootTabs: {
    marginBottom: '20px',
    color: '#828282',
    '& .MuiTab-root': {
      textTransform: 'uppercase',
      fontSize: '14px',
      fontWeight: 600
    },
    '& .MuiTabs-indicator': {
      backgroundColor: '#103a99'
    },
    '& .Mui-selected': {
      color: '#103a99'
    },
    '& .MuiTab-textColorInherit': {
      opacity: 1
    }
  },
  tabsTitles: {
    textTransform: 'capitalize',
  },
  table: {
    background: '#FFF',
    '&.MuiTable-root': {
      tableLayout: 'auto',
      minWidth: '1000px',
      overflowX: 'auto'
    },
    '& .MuiTableCell-root': {
      borderBottomColor: '#f8f8f8'
    },
    '& .MuiTableCell-head': {
      textTransform: 'uppercase',
      color: '#666687',
      fontWeight: '600',
      letterSpacing: 0,
      wordBreak: 'normal',
      fontSize: '11px',
      backgroundColor: '#EEF7FF',
      padding: '10px',
      lineHeight: 'inherit',
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#4277C6',
      '& .MuiSvgIcon-root': {
        fill: '#4B6FC2'
      }
    },
    '& .MuiTableCell-body': {
      color: '#32324D',
      padding: '12px 10px'
    },
    '& .MuiSvgIcon-root': {
      fontSize: '24px'
    },
    '& .MuiSvgIcon-root.MuiTableSortLabel-icon': {
      fontSize: '14px'
    },
    '& .MuiTableCell-paddingCheckbox': {
      width: '60px',
      padding: '0 10px'
    },
    '& .MuiTableRow-root:nth-child(odd)': {
      backgroundColor: '#f8f8f8'
    },
    '& .MuiTableRow-root.Mui-selected, .MuiTableRow-root.Mui-selected:hover': {
      backgroundColor: 'rgba(231, 240, 255, 0.8)'
    }
  },
  paginationContainer: {
    background: '#F2F9FF',
    color: '#32324D',
    width: '100%',

    '& .MuiSelect-icon': {
      color: '#32324D'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#32324D',
      opacity: '0.44'
    }
  },
}));

export default useStyles;
